var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChainCircleFilled = function SvgChainCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chain_circle_filled_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "chain_circle_filled_svg__b",
    width: 41,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h40v40H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.103 22.406a3.075 3.075 0 0 1-.903-4.257l3.355-5.158a3.076 3.076 0 0 1 5.627 2.234c-.08.4-.24.781-.468 1.12l-3.354 5.16a3.077 3.077 0 0 1-4.257.901m-3.757.31a6.15 6.15 0 0 1 .276-6.245l3.353-5.159a6.154 6.154 0 1 1 10.319 6.711l-3.354 5.159a6.153 6.153 0 0 1-10.594-.465",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M13.49 28.466a3.077 3.077 0 0 1-.902-4.257l3.355-5.158a3.075 3.075 0 0 1 5.153-.1 3.08 3.08 0 0 1 .006 3.454l-3.354 5.16a3.077 3.077 0 0 1-4.257.901m-3.756.31a6.15 6.15 0 0 1 .275-6.245l3.354-5.157a6.154 6.154 0 1 1 10.319 6.709l-3.354 5.159a6.155 6.155 0 0 1-10.594-.465",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chain_circle_filled_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.5 40c11.046 0 20-8.954 20-20s-8.954-20-20-20S.5 8.954.5 20s8.954 20 20 20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chain_circle_filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h40v40H.5z"
  })))));
};
export default SvgChainCircleFilled;